import * as React from "react";
import type { SVGProps } from "react";
const ConvenienceStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_7423)">
      <path
        fill="currentColor"
        d="M10.2245 3.4168c.2462-.4764.0606-1.0617-.4117-1.3079s-1.0616-.0605-1.3079.4117L4.747 9.7501H1.2918A1.2903 1.2903 0 0 0 0 11.0417c0 .7145.5772 1.2917 1.2917 1.2917l2.095 8.3758c.2865 1.1504 1.3199 1.9577 2.5066 1.9577H17.357c1.1868 0 2.2201-.8073 2.5067-1.9577l2.095-8.3758a1.2903 1.2903 0 0 0 1.2917-1.2917A1.2904 1.2904 0 0 0 21.9587 9.75h-3.4553l-3.758-7.2294c-.2462-.4722-.8315-.658-1.3078-.4117-.4763.2462-.658.8315-.4117 1.3078L16.3197 9.75h-9.389zM7.7501 14.271v3.875c0 .3552-.2906.6459-.6458.6459s-.6459-.2907-.6459-.6459v-3.875c0-.3553.2907-.6459.6459-.6459s.6458.2906.6458.6459m3.8751-.6459c.3552 0 .6458.2906.6458.6459v3.875c0 .3552-.2906.6459-.6458.6459s-.6459-.2907-.6459-.6459v-3.875c0-.3553.2907-.6459.6459-.6459m5.1667.6459v3.875c0 .3552-.2906.6459-.6458.6459s-.6459-.2907-.6459-.6459v-3.875c0-.3553.2907-.6459.6459-.6459s.6458.2906.6458.6459"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_7423">
        <path fill="transparent" d="M0 2h23.2504v20.667H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default ConvenienceStore;
